export function useExpenseAPI() {
  const { errors, request } = useRequest();
  const { t } = useEkI18n();
  const { openToast } = useUserMessages();
  const appApiFetch = getAppApiFetch();

  async function getExpenses(requestBody: GetExpensesRequest) {
    return await request<GetExpensesResponse>(versionedUrl('Expense/GetExpenses'), {
      method: 'post',
      body: requestBody
    });
  }

  async function getExpense(expenseId: number) {
    return await request<ExpenseResponseDTO>(`${versionedUrl('Expense/GetExpense')}?expenseId=${expenseId}`);
  }

  async function getExpenseConfiguration(fitterId: number) {
    return await request<ExpenseConfigurationResponse>(`${versionedUrl('Expense/GetExpenseConfiguration')}?fitterId=${fitterId}`);
  }

  async function createExpense(requestBody: CreateExpenseRequest) {
    const response = await request<ExpenseResponseDTO>(versionedUrl('Expense/CreateExpense'), {
      method: 'post',
      body: requestBody
    });

    return response;
  }

  async function updateExpense(requestBody: UpdateExpenseRequest) {
    const response = await request<ExpenseResponseDTO>(versionedUrl('Expense/UpdateExpense'), {
      method: 'post',
      body: requestBody
    });

    return response;
  }

  async function deleteExpense(expenseId: number, fitterId: number) {
    const response = await request<boolean>(versionedUrl('Expense/DeleteExpense'), {
      method: 'post',
      body: { ExpenseID: expenseId, FitterID: fitterId }
    });

    if (response && !response.HasErrors) {
      openToast(t('expense.alert.wasDeleted'), ToastType.SUCCESS);
    }

    return response;
  }

  async function getProjectsWithExpenses(fitterId: number) {
    return await request<ExpenseProjectResponseDTO[]>(`${versionedUrl('Expense/GetProjectsWithExpenses')}?fitterId=${fitterId}`);
  }

  async function getProjectDimensions(projectId: number) {
    return await request<ProjectDimensionsResponse>(`${versionedUrl('Expense/GetProjectDimensions')}?projectId=${projectId}`);
  }

  async function getExpenseFiles(expenseId: number) {
    return await appApiFetch<ResponseDTO<FileInfoResponse[]>>(`${versionedUrl('File/GetFileInfo')}?expenseId=${expenseId}`, { method: 'GET' });
  }

  async function analyzeInvoiceImage(blob: Blob, mimeType: string) {
    const formData = new FormData();
    formData.append('file', new File([blob], 'invoice', { type: mimeType || 'application/octet-stream' }));

    return await appApiFetch<ResponseDTO<InvoiceAnalysisResultDTO>>(versionedUrl('Expense/AnalyzeInvoice'), {
      method: 'POST',
      body: formData
    });
  }

  return {
    errors,
    getExpenses,
    getExpense,
    getExpenseConfiguration,
    createExpense,
    updateExpense,
    deleteExpense,
    getProjectsWithExpenses,
    getProjectDimensions,
    getExpenseFiles,
    analyzeInvoiceImage
  };
}
